import { api } from 'data/api/api'

import { submitPaymentsIdentityArgsToParams } from '../transformers/payments-identity'
import {
  SubmitPaymentsIdentityArgs,
  PaymentsIdentityFormConfigurationResp,
} from '../types/payments-identity'

export const submitPaymentsIdentity = (args: SubmitPaymentsIdentityArgs) =>
  api.put<PaymentsIdentityFormConfigurationResp>('/payments/identity', {
    payments_identity: submitPaymentsIdentityArgsToParams(args),
  })

export const getPaymentsIdentityFormConfiguration = () =>
  api.get<PaymentsIdentityFormConfigurationResp>('/payments/identity/edit')
